/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Alternatives_Exit_KickerInputs */

const en_directory_alternatives_exit_kicker = /** @type {(inputs: Directory_Alternatives_Exit_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keep exploring`)
};

const zh_directory_alternatives_exit_kicker = /** @type {(inputs: Directory_Alternatives_Exit_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续探索`)
};

/**
* | output |
* | --- |
* | "Keep exploring" |
*
* @param {Directory_Alternatives_Exit_KickerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_alternatives_exit_kicker = /** @type {((inputs?: Directory_Alternatives_Exit_KickerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Alternatives_Exit_KickerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_alternatives_exit_kicker(inputs)
	return zh_directory_alternatives_exit_kicker(inputs)
});
export { directory_alternatives_exit_kicker as "directory.alternatives.exit_kicker" }